type Variant = (typeof variants)[number];

const variants = ["agrotrade", "cleverfarm", "mymex"] as const;

export type { Variant };
export { variants };
